export function checkLocalStorage() {
    try {
        window.localStorage
        return true
    } catch (error) {
        return false
    }
}

export function checkSessionStorage() {
    try {
        window.sessionStorage
        return true
    } catch (error) {
        return false
    }
}


// WEBPACK FOOTER //
// ./src/helpers/check-storage.js